<template>
  <div style="overflow: hidden;height:100%">
    <div class="top">
      <img
        src="../../img/qpxq/return.png"
        alt=""
        class="return"
        @click="gosy()"
      />
      <div class="bt">扫码查询</div>
    </div>
    <!-- <div class="bt1">请扫描钢瓶二维码</div> -->
    <div class="qrcode">
      <vue-qrcode></vue-qrcode>
    </div>
  </div>
</template>

<script>
import qrcode from "./qrcode.vue";

export default {
  data() {
    return {};
  },
  components: {
    "vue-qrcode": qrcode,
  },
  created() {},
  destroyed() {},
  computed: {},
  mounted() {},
  methods: {
    gosy() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
<style scoped>
.bt {
  position: absolute;
  left: 35vw;
  top: 4vw;
  width: 30vw;
  text-align: center;
  font-size: 4vw;
  font-weight: 600;
}
.bt1 {
  text-align: center;
  margin-top: 10vw;
  font-size: 4vw;
  font-weight: 500;
}
.qrcode {
  width: 100vw;
  height: 100%;
  position: relative;
  /* top: 5vw; */
  overflow: hidden;
}
.top {
  height: 12vw;
  width: 100vw;
  position: relative;
  background-color: rgb(245, 247, 251);
}
.return {
  width: 5vw;
  margin-top: 1.8vw;
  margin-left: 4vw;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/ypscan.vue